import type { RequestComfortScanParams } from '../../../../../services/dmMonitoringControl';
import type { MonitoringState } from './dmControlUtils';

export const COMFORT_COMMENT_MAX_LENGTH = 1000;

const DISABLED_REASON: Record<Exclude<MonitoringState, 'active'>, string> = {
    paused: 'Needs active monitoring: resume it first',
    stopped: 'Needs active monitoring: it has stopped',
    not_started: "Needs active monitoring: it hasn't started"
};

/** Why DM won't take a scan or aligner request now, or null while monitoring is active. */
export function patientRequestDisabledReason(status: MonitoringState): string | null {
    return status === 'active' ? null : DISABLED_REASON[status];
}

export function comfortScanParams(message: string): RequestComfortScanParams {
    const comment = message.trim();
    return comment ? { comment } : {};
}
